module.exports = __webpack_public_path__ + "static/img/login.f037f24b.png";